<div class="row">
    <div class="col-4">
        <form #frm_addJob="ngForm" (ngSubmit)="saveAddJob(frm_addJob.value); resetFormAddJob()"
            novalidate>
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title text-primary"><i class="fas fa-plus-circle"></i> เพิ่ม/แก้ไข ข้อมูลตำแหน่งงาน</h3>
                    <div class="card-tools text-primary ">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label for="dep_id" class="col-sm-2 col-form-label">แผนก</label>
                        <div class="col-sm-10">
                            <select #dep_id="ngModel" ngModel name="dep_id" class="form-control" required
                                [ngClass]="{ 'is-invalid' : dep_id.invalid && (dep_id.dirty || dep_id.touched )}"
                                [(ngModel)]="jobEdit.dep_id">
                                <option selected>++เลือกแผนก++</option>
                                <option [value]="item.dep_id" *ngFor="let item of depData">{{ item.dep_name }}
                                </option>
                            </select>
                            <div class="invalid-feedback">
                                <span *ngIf="dep_id.hasError('required')">กรุณาเลือกแผนก</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="jobName" class="col-sm-2 col-form-label">ชื่อตำแหน่งงาน</label>
                        <div class="col-sm-10">
                            <input #jobName="ngModel" ngModel name="jobName" class="form-control"
                                placeholder="ป้อนชื่อตำแหน่ง" required
                                [ngClass]="{ 'is-invalid' : jobName.invalid && (jobName.dirty || jobName.touched )}"
                                [(ngModel)]="jobEdit.jobName">
                            <div class="invalid-feedback">
                                <span *ngIf="jobName.hasError('required')">กรุณาป้อนชื่อตำแหน่งงาน</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="jobResponsive" class="col-sm-2 col-form-label">งานที่รับผิดขอบ</label>
                        <div class="col-sm-10">
                            <input #jobResponsive="ngModel" ngModel name="jobResponsive" class="form-control"
                                placeholder="ป้อนงานที่รับผิดขอบ" required
                                [ngClass]="{ 'is-invalid' : jobResponsive.invalid && (jobResponsive.dirty || jobResponsive.touched )}"
                                [(ngModel)]="jobEdit.jobResponsive">
                            <div class="invalid-feedback">
                                <span *ngIf="jobResponsive.hasError('required')">กรุณาป้อนงานที่รับผิดขอบ</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="educational" class="col-sm-2 col-form-label">วุฒิการศึกษา</label>
                        <div class="col-sm-10">
                            <input #educational="ngModel" ngModel name="educational" class="form-control"
                                placeholder="วุฒิการศึกษา" required
                                [ngClass]="{ 'is-invalid' : educational.invalid && (educational.dirty || educational.touched )}"
                                [(ngModel)]="jobEdit.educational">
                            <div class="invalid-feedback">
                                <span *ngIf="educational.hasError('required')">กรุณาป้อนวุฒิการศึกษาของตำแหน่งงาน</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="fieldStudy" class="col-sm-2 col-form-label">สาขาวิชา</label>
                        <div class="col-sm-10">
                            <input #fieldStudy="ngModel" ngModel name="fieldStudy" class="form-control"
                                placeholder="สาขาวิชา" required
                                [ngClass]="{ 'is-invalid' : fieldStudy.invalid && (fieldStudy.dirty || fieldStudy.touched )}"
                                [(ngModel)]="jobEdit.fieldStudy">
                            <div class="invalid-feedback">
                                <span *ngIf="fieldStudy.hasError('required')">กรุณาป้อนสาขาวิชาของตำแหน่งงาน</span>
                            </div>
                        </div>
                    </div>
                    <input #dataid="ngModel" ngModel name="dataid" type="hidden" [(ngModel)]="jobEdit.dataid">
                </div>
                <div class="card-footer">
                    <div class="btn-group btn-group-md">
                        <button type="submit" class="btn btn-info"
                            [disabled]="frm_addJob.invalid || formEdit">เพิ่มข้อมูล</button>
                        <button (click)="saveEditJob(frm_addJob.value)" type="button"
                            class="btn btn-warning ml-1" *ngIf="formEdit">แก้ไขข้อมูล</button>
                        <!-- <button type="button" class="btn btn-danger ml-1" 
                                    *ngIf="formEdit">ลบข้อมูล</button>  -->
                        <button (click)="resetFormAddJob()" type="reset"
                            class="btn btn-secondary ml-1">กรอกใหม่</button>
                    </div>
                </div>
            </div>
        </form>
        <!-- {{ frm_addJob.value | json }} -->
    </div>

    <div class="col-8">
        <div class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title text-primary"><i class="far fa-address-card"></i> ข้อมูลตำแหน่ง</h3>
                <button (click)="jobtitleList()" type="button" class="btn btn-link" data-toggle="tooltip"
                    title="Refresh">
                    <i class="fa fa-rotate-right"></i></button>
                <div class="card-tools">
                    <!-- <span data-toggle="tooltip" title="3 New Messages" class="badge bg-primary">3</span> -->
                    <button (click)="jobtitleList()" type="button" class="btn btn-tool" data-toggle="tooltip"
                        title="Refresh">
                        <i class="	fas fa-circle-notch"></i></button>
                    <button (click)="exportExcel()" type="button" class="btn btn-tool" data-toggle="tooltip"
                        title="Download Excel">
                        <i class="	fas fa-file-excel"></i></button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                    </button>
                </div>
            </div>
            <div class="card-body table-responsive p-2" style="height: 400px">
                <table #tb_data class="table table-hover table-head-fixed text-nowrap" id="position-table">
                    <thead>
                        <tr class="text-primary">
                            <th>#</th>
                            <th>ชื่อตำแหน่ง</th>
                            <th>แผนก</th>
                            <th>ส่วน</th>
                            <th>ฝ่าย</th>
                            <th class="text-center"><i class="fas fa-bars"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr (click)="editJob(item.dataid)" *ngFor="let item of jobData">
                            <td>{{ item.dataid }}</td>
                            <td>{{ item.jobName }}</td>
                            <td>{{ item.dep_name }}</td>
                            <td>{{ item.partname }}</td>
                            <td>{{ item.faction_name }}</td>
                            <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                            <td class="text-center text-primary align-middle">
                                <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                    data-bs-target="#explan_plant">
                                    <i class="fas fa-edit"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>